import { Alerter, Intent } from '@pinpointhq/thumbtack';
import { SpraypaintBase } from 'spraypaint';
import { createSuccessfulSaveToast, createToast, createUnsuccessfulSaveToast } from '../../';
import { reportHandledError } from '../../../utilities/reportError';

interface IHandleGraphitiDeleteProps {
  /**
   * Lowercase name of instance name e.g. 'webhook endpoint'
   * Makes it easier than having to use inflections on the JSON API type
   */
  name: string;
  /**
   * Graphiti instance that we'd like to remove
   */
  resource: SpraypaintBase;
  /**
   * Whether this should use an alert to confirm delete before acting
   * @default true
   */
  confirm?: boolean;
  /**
   * Callback function to run before the delete request is made
   */
  beforeCallback?(): void;
  /**
   * Callback function to run after everything
   */
  finalCallback?(): void;
  /**
   * Callback function to run after success
   */
  successCallback?(): void;
}

export function handleGraphitiDelete({
  name,
  confirm = true,
  resource,
  beforeCallback = () => {
    /* does nothing */
  },
  finalCallback = () => {
    /* does nothing */
  },
  successCallback = () => {
    /* does nothing */
  },
}: IHandleGraphitiDeleteProps) {
  confirm ? confirmDelete() : handleDelete();

  function confirmDelete() {
    Alerter.create({
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Yes, Delete',
      intent: Intent.DANGER,
      onConfirm: handleDelete,
      text: `Are you sure you want to delete this ${name}?`,
    });
  }

  function handleDelete() {
    beforeCallback();
    const toastKey = resource.id;
    createToast({ isLoading: true, key: toastKey, text: `Deleting ${name}...` });
    resource
      .destroy()
      .then((success) => {
        if (success) {
          createSuccessfulSaveToast({ name, toastKey, verb: 'deleted' });
          successCallback();
        } else {
          createUnsuccessfulSaveToast({ resource, toastKey });
        }
      })
      .catch((error) => {
        reportHandledError(error);
        createToast({ key: toastKey, type: 'error', text: `Could not delete ${name}` });
      })
      .finally(finalCallback);
  }
}
